<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      @if (!lifeplanSelected) {
        <h1 class="title">Crear Plan de Vida</h1>
      }
    </div>
    <div class="title-color">
      @if (lifeplanSelected) {
        <h1 class="title">Editar Plan de Vida</h1>
      }
    </div>
    <div class="form-body">
      <form [formGroup]="lifeplanForm" (ngSubmit)="saveLifeplan()">
        <div class="line">
          <div class="form-grid">
            <mat-form-field appearance="outline">
              <mat-label>Nombre</mat-label>
              <input
                type="text"
                matInput
                placeholder="Nombre"
                formControlName="name"
                maxlength="256"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (lifeplanForm.get('name')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (lifeplanForm.get('name')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 256 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Código</mat-label>
              <input
                type="text"
                matInput
                placeholder="Código"
                formControlName="code"
                maxlength="256"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (lifeplanForm.get('code')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (lifeplanForm.get('code')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 256 caracteres
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <button type="submit" class="primary-button" [disabled]="!lifeplanForm.touched">
          <span class="button-content"> <mat-icon fontIcon="save"></mat-icon>Guardar </span>
        </button>

        <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
          <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
        </button>
      </form>
    </div>
  </div>
</div>
